import dashboard_icon from 'src/assets/images/sidenav-dashboard.svg'
import questions_icon from 'src/assets/images/sidenav-questions.svg'
import exercises_icon from 'src/assets/images/sidenav-exercises.svg'
import exercises_archive_icon from 'src/assets/images/sidenav-exercises-archive.svg'
import exams_archive_icon from 'src/assets/images/sidenav-exams-archive.svg'
import exams_icon from 'src/assets/images/sidenav-exams.svg'
import planned_icon from 'src/assets/images/sidenav-planned.svg'
import liked_icon from 'src/assets/images/sidenav-liked.svg'
import subscriptions_icon from 'src/assets/images/sidenav-subscriptions.svg'
import notifications_icon from 'src/assets/images/sidenav-notifications.svg'
import reports_icon from 'src/assets/images/sidenav-reports.svg'
import users_icon from 'src/assets/images/sidenav-users.svg'
import classes_icon from 'src/assets/images/sidenav-classes.svg'
import subjects_icon from 'src/assets/images/sidenav-subjects.svg'
import topics_icon from 'src/assets/images/sidenav-topics.svg'
import sub_topics_icon from 'src/assets/images/sidenav-subtopics.svg'
import test_types_icon from 'src/assets/images/sidenav-testtypes.svg'
import history_icon from 'src/assets/images/sidenav-history.svg'

export const roleNames = { student: 'Student', teacher: 'Teacher' }
export const rolesList = [roleNames.teacher, roleNames.student]
export const studentNavItems = [
  { title: 'Home', icon: dashboard_icon, to: '/student', isHomeRoute: true },
  { title: 'History', icon: history_icon, to: '/student/history' },
  { title: 'Planned', icon: planned_icon, to: '/student/planned' },
  { title: 'Liked', icon: liked_icon, to: '/student/liked' },
  {
    title: 'Subscriptions',
    icon: subscriptions_icon,
    to: '/student/subscriptions',
  },
  { title: 'Notifications', icon: notifications_icon, to: '/student/notifications' },
  { title: 'Reports', icon: reports_icon, to: '/student/reports' },
]

export const teacherNavItems = [
  { title: 'Dashboard', icon: dashboard_icon, to: '/teacher', isHomeRoute: true },
  { title: 'Questions', icon: questions_icon, to: '/teacher/questions' },
  { title: 'Exercises', icon: exercises_icon, to: '/teacher/exercises' },
  { title: 'Exercises (Archive)', icon: exercises_archive_icon, to: '/teacher/archive-exercises' },
  { title: 'Exams', icon: exams_icon, to: '/teacher/exams' },
  { title: 'Exams (Archive)', icon: exams_archive_icon, to: '/teacher/archive-exams' },
]
export const adminNavItems = [
  { title: 'Home', icon: dashboard_icon, to: '/admin', isHomeRoute: true },
  { title: 'Users', icon: users_icon, to: '/admin/users' },
  { title: 'Classes', icon: classes_icon, to: '/admin/classes' },
  { title: 'Subjects', icon: subjects_icon, to: '/admin/subjects' },
  { title: 'Topics', icon: topics_icon, to: '/admin/topics' },
  { title: 'Sub Topics', icon: sub_topics_icon, to: '/admin/sub-topics' },
  { title: 'Test Types', icon: test_types_icon, to: '/admin/test-types' },
  { title: 'Exercises', icon: exercises_icon, to: '/admin/exercises' },
  { title: 'Exams', icon: exams_icon, to: '/admin/exams' },
]

export const verifierNavItems = [
  { title: 'Home', icon: dashboard_icon, to: '/verifier', isHomeRoute: true },
  { title: 'Exercises', icon: exercises_icon, to: '/verifier/exercises' },
  { title: 'Exams', icon: exams_icon, to: '/verifier/exams' },
]

export const questionTypes = [
  { name: 'Yes/No', key: 1 },
  { name: 'True/False', key: 2 },
  { name: 'MCQs (Single-answer)', key: 3 },
  { name: 'MCQs (Multi-answer)', key: 4 },
]

export const difficultyLevels = Array.from({ length: 10 }, (_, i) => ({
  name: (i + 1).toString(),
  key: (i + 1).toString(),
}))

export const sectionOptions = Array.from({ length: 4 }, (_, i) => ({
  name: (i + 1).toString(),
  key: (i + 1).toString(),
}))
export const questionHeaders = [
  'Class/Grade',
  'Subject',
  'Topic',
  'Sub Topic',
  'Difficulty Level',
  'Question Type',
  'Question',
  'Choice A',
  'Choice B',
  'Choice C',
  'Choice D',
  'Correct Answer',
  'Explanation',
]

export const multipleChoiceTypes = ['MCQs (Single-answer)', 'MCQs (Multi-answer)']

export const formatValue = (val) => (val ? val.toString().trim().toLowerCase() : '')

export const createExamsHeaders = [
  'Title',
  'Introduction',
  'Feedback',
  'Keywords',
  'Private (true/false)',
  'Academic (true/false)',
  'Test Type',
  'Class/Grade',
  'Subject',
  'Topic',
  'Sub Topic',
  'Scheduled (true/false)',
  'Start Date (YYYY-MM-DD HH:mm)',
  'End Date (YYYY-MM-DD HH:mm)',
  'Time In Minutes (Minutes)',
]

export const createExercisesHeaders = [
  'Title',
  'Introduction',
  'Feedback',
  'Keywords',
  'Private (true/false)',
  'Academic (true/false)',
  'Test Type',
  'Class/Grade',
  'Subject',
  'Topic',
  'Sub Topic',
]

export const createExamsValues = {
  title: '',
  introduction: '',
  isPrivate: false,
  isAcademic: '',
  classKey: '',
  subjectKey: '',
  topicKey: '',
  subTopicKey: '',
  typeKey: '',
  isScheduled: '',
  timeInMinutes: '',
  start: null,
  end: null,
  noOfSections: '1',
  keywords: [],
  currentKeyword: '',
  feedback: '',
}

export const createExercisesValues = {
  title: '',
  introduction: '',
  isPrivate: false,
  isAcademic: '',
  classKey: '',
  subjectKey: '',
  topicKey: '',
  subTopicKey: '',
  typeKey: '',
  keywords: [],
  currentKeyword: '',
  feedback: '',
}
export const QuestionSortColumns = {
  content: 'QUESTION_TEXT',
  difficultyLevel: 'DEFAULT_DIFFICULTY_LEVEL',
  typeName: 'QUESTION_TYPE',
  className: 'CLASS_NAME',
  subjectName: 'SUBJECT_NAME',
  topicName: 'TOPIC_NAME',
  subTopicName: 'SUB_TOPIC_NAME',
}

export const TeacherTestSortColumns = {
  title: 'TEST_TITLE',
  typeName: 'TEST_TYPE',
  className: 'CLASS_NAME',
  subjectName: 'SUBJECT_NAME',
  topicName: 'TOPIC_NAME',
  subTopicName: 'SUB_TOPIC_NAME',
}

export const formatDate = (date) => {
  if (!date) return '-'
  return new Date(date).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

export const typeColors = {
  'Yes/No': {
    bg: '#D0FBE9',
    text: '#16643B',
  },
  'MCQs (Single-answer)': {
    bg: '#E0D5FF',
    text: ' #491EBE',
  },
  'True/False': {
    bg: '#CEEFFF',
    text: '#0C6998',
  },
  'MCQs (Multi-answer)': {
    bg: ' #FFEBEC',
    text: '#E93544',
  },
}

export const difficultyColors = {
  1: '#4CAF50',
  2: '#7BC96F',
  3: '#A3D580',
  4: '#D7D967',
  5: '#FFEB3B',
  6: '#FFC107',
  7: '#FF9800',
  8: '#FF5722',
  9: '#F44336',
  10: '#B71C1C',
}

export const isAnyFilterApplied = (filters) => {
  if (!filters) return false
  return Object.values(filters).some((value) => {
    if (Array.isArray(value)) return value.length > 0
    return value?.toString().trim() !== ''
  })
}

export const getChoices = (typeKey, choices = []) => {
  switch (typeKey) {
    case 1:
      return [
        { choiceCode: 'Yes', choiceText: 'Yes' },
        { choiceCode: 'No', choiceText: 'No' },
      ]
    case 2:
      return [
        { choiceCode: 'True', choiceText: 'True' },
        { choiceCode: 'False', choiceText: 'False' },
      ]
    default:
      return (choices || []).filter((c) => {
        const text = c.choiceText || ''
        const stripped = text.replace(/<[^>]*>?/gm, '').trim()
        const hasMedia =
          /<(img|iframe|video|audio|math|svg)/i.test(text) ||
          text.includes('\\(') ||
          text.includes('\\[')
        return stripped !== '' || hasMedia
      })
  }
}
